import { DI } from '@microsoft/fast-foundation';
import { Connect, Message, SocketObservable } from '@genesislcap/foundation-comms';

export interface IAuditTrail {
  getVppaAudit(vppaUniqueId: string): Promise<Message<any>>;
  getRfqAudit(rfqUniqueId: string): Promise<Message<any>>;
  getNegotiationAudit(negotiationUniqueId: string): Promise<Message<any>>;
}

class AuditTrailImpl implements IAuditTrail {
  constructor(@Connect private connect: Connect) {}

  getVppaAudit(vppaUniqueId: string): Promise<Message<any>> {
    const request = this.connect.request('VPPA_AUDIT_TRAIL', {
      REQUEST: {
        UNIQUE_ID: vppaUniqueId,
      },
    });
    return request;
  }
  getRfqAudit(rfqUniqueId: string): Promise<Message<any>> {
    const request = this.connect.request('RFQ_AUDIT_TRAIL', {
      REQUEST: {
        UNIQUE_ID: rfqUniqueId,
      },
    });
    return request;
  }

  getNegotiationAudit(negotiationUniqueId: string): Promise<Message<any>> {
    const request = this.connect.request('NEGOTIATION_AUDIT_TRAIL', {
      REQUEST: {
        UNIQUE_ID: negotiationUniqueId,
      },
    });
    return request;
  }
}

export const IAuditTrail = DI.createInterface<IAuditTrail>((x) => x.singleton(AuditTrailImpl));
